// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"info-box__box--23wYs"};